// Внутри Telegram ссылку открываем через WebApp.openLink — так она уходит во
// внешний браузер, а не в WebView мини-аппа. Вне Telegram (dev-мок) — обычный window.open.
export const openExternalLink = (url: string) => {
  const webApp = window.Telegram?.WebApp;
  if (typeof webApp?.openLink === "function") {
    webApp.openLink(url);
    return;
  }
  window.open(url, "_blank", "noopener");
};
